import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../app/auth/Login";
import AdminMainLayout from "../../components/layout/AdminMainLayout";
import NotificationManagement from "../../components/notificationManagement/NotificationManagement";

const DrawerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

const NotificationManagementPage = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <div className="h-[var(--app-height)] overflow-hidden">
          <Box className="flex h-full">
            {/* Sidebar */}
            <AdminMainLayout />

            {/* Main content */}
            <Box
              component="main"
              className="flex-1 bg-white px-6 py-4 overflow-hidden"
            >
              <DrawerHeader />
              {/* Add more content here as needed */}

              <NotificationManagement />
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default NotificationManagementPage;
